<template>
    <div class="side-menu-wrapper">
        <slot></slot>

        <Menu ref="menu" v-show="!collapsed" :active-name="activeName" :open-names="openedNames" :accordion="accordion"
              :theme="theme" width="auto" @on-select="handleSelect">
            <template v-for="item in menuList">
                <side-menu-item v-if="item.children && item.children.length>=1" :key="`menu-${item.name}`"
                                :parent-item="item"></side-menu-item>
                <menu-item v-else :name="item.name" :key="`menu-${item.name}`">
                    <common-icon :type="item.icon || ''"/>
                    <span>{{ item.title }}</span></menu-item>
            </template>
        </Menu>
        <div class="menu-collapsed" v-show="collapsed" :list="menuList">
            <template v-for="item in menuList">
                <collapsed-menu v-if="item.children && item.children.length >= 1" @on-click="handleSelect" hide-title
                                :root-icon-size="rootIconSize" :icon-size="iconSize" :theme="theme" :parent-item="item"
                                :key="`drop-menu-${item.name}`"></collapsed-menu>
                <Tooltip transfer v-else :content="item.title" placement="right" :key="`drop-menu-${item.name}`">
                    <a @click="handleSelect(item.name)" class="drop-menu-a"
                       :style="{textAlign: 'center'}">
                        <common-icon :size="rootIconSize" :color="textColor"
                                     :type="item.icon"/>
                    </a>
                </Tooltip>
            </template>
        </div>
    </div>
</template>
<script>
    import SideMenuItem from './side-menu-item.vue'
    import CollapsedMenu from './collapsed-menu.vue'
    import {getUnion} from '@/libs/tools'
    import mixin from './mixin'

    export default {
        name: 'SideMenu',
        mixins: [mixin],
        components: {
            SideMenuItem,
            CollapsedMenu
        },
        props: {
            menuList: {
                type: Array,
                default() {
                    return []
                }
            },
            collapsed: {
                type: Boolean
            },
            theme: {
                type: String,
                default: 'dark'
            },
            rootIconSize: {
                type: Number,
                default: 20
            },
            iconSize: {
                type: Number,
                default: 16
            },
            accordion: Boolean,
            activeName: {
                type: String,
                default: ''
            }
        },
        mounted () {
            this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
        },
        data() {
            return {
                openedNames: []
            }
        },
        methods: {
            handleSelect(name) {
                this.$emit('on-select', name)
            },
            getOpenedNamesByAuth(id) {
                /*if (!pname) {
                    return []
                }
                let item = menu.find(e => e.name === pname);
                if (item) {
                    return [,item.name];
                } else {
                    return [];
                }*/

                let item = this.$store.getters.auth.find(e => e.id === id);
                if (item) {
                    return [,...this.getOpenedNamesByAuth(item.parentId), item.name];
                } else {
                    return [];
                }
            },
            /*updateOpenName(name) {
                //let item = menu.find(e => e.name === name);
                /!*let item = this.findMenu(name, menu)
                item = item ? (item.pname?this.getOpenedNamesByAuth(item.pname):[,item.name]) : [];
                this.openedNames = this.accordion ? item : getUnion(this.openedNames, item);*!/

                let item = this.$store.getters.auth.find(e => e.name === name);
                item = item ? this.getOpenedNamesByAuth(item.parentId) : [];
                this.openedNames = this.accordion ? item : getUnion(this.openedNames, item);
            },*/
            getOpenedNamesByActiveName (name) {
                return this.$route.matched.map(item => item.name).filter(item => item !== name)
            },
            updateOpenName (name) {
                if (name === 'home') this.openedNames = []
                else this.openedNames = this.getOpenedNamesByActiveName(name)
            },
            findMenu(name, menu) {
                for (var i = 0; i < menu.length; i++) {
                    if (menu[i].name === name) {
                        return menu[i]
                    }
                    if (menu[i].children && menu[i].children.length > 0) {
                        let citem = this.findMenu(name, menu[i].children)
                        if (citem) {
                            return citem
                        }
                    }
                }
                return '';
            }
        },
        computed: {
            textColor() {
                return this.theme === 'dark' ? '#fff' : '#495060'
            }
        },
        watch: {
            /*activeName(name) {
                this.updateOpenName(name);
            },
            openedNames() {
                this.$nextTick(() => {
                    this.$refs.menu.updateActiveName();
                    this.$refs.menu.updateOpened();
                })
            }*/
            activeName (name) {
                if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name)
                else this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
            },
            openedNames () {
                this.$nextTick(() => {
                    this.$refs.menu.updateOpened()
                })
            }
        }
    }
</script>
<style lang="less">
    @import './side-menu.less';

    .ivu-menu {
        z-index: 0 !important;
    }

    .side-menu-wrapper{
        &>.ivu-menu{
            &>.ivu-menu-item{
                &>i{
                    margin-right:8px !important;
                }
            }
        }
    }

</style>
